<template>
<div id="consulta_adjuntos_pedimentos" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Consulta Archivos Adjuntos" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'in-view'" >Vista Previa Indicadores de Check List-EEA</v-tab>
            <v-tab :key="'in-report'" >Generar en Reporte</v-tab>

            <v-tab-item :key="'in-view'" >
              <v-card-text>
                <v-card-title>
                  <span class="headline" ></span>
                </v-card-title>
                <v-form ref="form1" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                      <v-flex x12 s6 m6 l6>
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()"
                          :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="model.tipo_reporte == 1" row wrap>
                      <v-row>
                        <v-col cols="10" >
                          <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required, validaPedimento]" ></v-text-field>
                        </v-col>
                        <v-col cols="2" >
                            <v-btn icon title="Pegar Listado" @click="listado=''; dialog1 = !dialog1" v-tippy>
                                <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                            </v-btn>
                        </v-col>
                      </v-row>
                    </v-layout>

                    <v-layout v-if="model.tipo_reporte == 3" row wrap>
                      <v-row>
                        <v-col cols="12" >
                          <v-text-field v-model="model.archivo" label="Nombre Documento" prepend-icon="fa-search" :rules="[rules.required, validaArchivo]" maxlength="50" ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-layout>

                    <v-layout v-if="model.tipo_reporte == 2" row wrap>
                      <v-flex s12 m6 l6>

                        <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" >
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu3 = false" >
                            <v-spacer />

                            <v-btn color="secondary" large @click="menu3 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex s12 m6 l6>
                        <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" ></v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu4 = false" >
                            <v-spacer />

                            <v-btn color="secondary" large @click="menu4 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn rounded color="success" @click="get_data_view()" :loading="loading" >
                  <v-icon>done</v-icon>Vista Previa
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-client-table ref="vuetabledetallepreview" :data="data_resumen_preview" :columns="columns_resumen" :options="options_resumen" class="elevation-2 pa-2" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                    </template>
                    <template slot="checklist" slot-scope="props" >
                        <div style="text-align:left" v-if="props.row.checklist!=undefined"
                          @click="openModalDetalle(props.row.checklist, props.row.numero_pedimento, props.row.anio)" :class="['showModal']" >
                            {{ props.row.checklist }}
                        </div>
                        <span v-else>No aplica Check List</span>
                    </template>
                </v-client-table>
              </v-card-text>
            </v-tab-item>
            <v-tab-item :key="'in-report'" >
              <v-card-text>
                <v-card-title>
                  <span class="headline" ></span>
                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                      <v-flex x12 s6 m6 l6>
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()"
                          :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="model.tipo_reporte == 1" row wrap>
                      <v-row>
                        <v-col cols="10" >
                          <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required, validaPedimento]" ></v-text-field>
                        </v-col>
                        <v-col cols="2" >
                            <v-btn icon title="Pegar Listado" @click="listado=''; dialog2 = !dialog2" v-tippy>
                                <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                            </v-btn>
                        </v-col>
                      </v-row>
                    </v-layout>

                    <v-layout v-if="model.tipo_reporte == 3" row wrap>
                      <v-row>
                        <v-col cols="12" >
                          <v-text-field v-model="model.archivo" label="Nombre Documento" prepend-icon="fa-search" :rules="[rules.required, validaArchivo]" maxlength="50" ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-layout>

                    <v-layout v-if="model.tipo_reporte == 2" row wrap>
                      <v-flex s12 m6 l6>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" >
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false" >
                            <v-spacer />

                            <v-btn color="secondary" large @click="menu1 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex s12 m6 l6>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false" >
                            <v-spacer />

                            <v-btn color="secondary" large @click="menu2 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn rounded color="success" @click="generar_reporte_sqs(0)" :loading="loading" >
                  <v-icon>done</v-icon>Generar Reporte
                </v-btn>
              </v-card-actions>
              <v-card-text>
                    <v-refresh-button :funcion="cargar" />
                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                        <template slot="noResults" >
                            <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                        </template>

                        <template slot="actions" slot-scope="props" >
                            <v-btn text icon color="success" title="Ver Expediente" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="cargarDetalle(props.row.id)" >
                                <v-icon dark>folder</v-icon>
                            </v-btn>
                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                <v-icon dark>delete</v-icon>
                            </v-btn>
                        </template>
                    </v-client-table>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- MODAL DETALLES -->
    <v-dialog v-model="modal" max-width="80%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>
                    <span class="subheading" >
                        <strong>Adjuntos de Pedimentos</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <exportar-excel :data="data_resumen" :exportFields="data_resumen_excel" name="Resumen_Adjuntos.xlsx" >
                    <v-btn dark small color="success" title="Exportar Resumen" v-tippy>
                        <v-icon dark>get_app</v-icon> RESUMEN DE CUMPLIMIENTO-CHECK LIST
                    </v-btn>
                </exportar-excel>
                &nbsp;&nbsp;&nbsp;
                <v-btn dark small color="success" title="Exportar Detalle"
                    v-tippy @click="downloadFile(data_detalle)"
                    v-if="(typeof data_detalle === 'string' || data_detalle instanceof String)" >
                    <v-icon dark>get_app</v-icon> DETALLE DE ADJUNTOS-CHECK LIST
                </v-btn>
                <exportar-excel v-else :data="data_detalle" :exportFields="data_detalle_excel" name="Detalle_Adjuntos.xlsx" >
                    <v-btn dark small color="success" title="Exportar Detalle" v-tippy>
                        <v-icon dark>get_app</v-icon> DETALLE DE ADJUNTOS-CHECK LIST
                    </v-btn>
                </exportar-excel>
            </v-card-actions>
            <v-card-text>
                <span><strong>Resumen Adjuntos de Pedimentos</strong></span>
                <v-client-table ref="vuetabledetalle" :data="data_resumen" :columns="columns_resumen" :options="options_resumen" class="elevation-2 pa-2" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                    </template>
                    <template slot="checklist" slot-scope="props" >
                        <div style="text-align:left" v-if="props.row.checklist!=undefined"
                          @click="openModalDetalle(props.row.checklist, props.row.numero_pedimento, props.row.anio)" :class="['showModal']" >
                            {{ props.row.checklist }}
                        </div>
                    </template>
                </v-client-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false" >
                    <v-icon>cancel</v-icon>Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  <v-dialog v-model="dialog1" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de pedimentos</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="" >
                    <v-textarea outlined
                        rows="15"
                        v-model="listado"
                        :rules="[validaListadoPreview]"
                        ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
                <v-btn  small color="primary" @click="generaReporteListado('preview');" >Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  <v-dialog v-model="dialog2" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de pedimentos</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="" >
                    <v-textarea outlined
                        rows="15"
                        v-model="listado"
                        :rules="[validaListado]"
                        ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  small @click="listado=''; dialog2 = false" >Cancelar</v-btn>
                <v-btn  small color="primary" @click="generaReporteListado('completo');" >Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="modal_detalle" max-width="60%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal_detalle = false" class="white--text" >cancel</v-icon>
                    <span class="subheading" >
                        <strong>{{ titleModalDetalle }}</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <exportar-excel :data="dataChecklist.items" :exportFields="porcentaje_detalle" :name='"Adjuntos_"+titleModalDetalle+".xlsx"'>
                      <v-btn dark small color="success" title="Exportar" v-tippy>
                            <v-icon dark>get_app</v-icon> Exportar
                        </v-btn>
                    </exportar-excel>
                </v-card-actions>
                {{cumplimientoCheck}}
                <v-container grid-list-md>
                        <v-client-table ref="vuetabletiposfiltrados" :data="dataChecklist.items"
                            :columns="dataChecklist.columnsFiltrados" :options="dataChecklist.optionsFiltrados" class="elevation-2 pa-2 scroll-table" >
                            <template slot="noResults" >
                                <v-alert :value="true" icon="info" color="info" >No se encontraron resultados...</v-alert>
                            </template>
                            <template slot="documentos" slot-scope="props" >
                              <div class="documentos_checklist" >
                                {{ props.row.documentos }}
                              </div>
                            </template>
                            <template slot="descripcion" slot-scope="props" >
                              <div class="documentos_descripcion" >
                                {{ props.row.descripcion }}
                              </div>
                            </template>
                        </v-client-table>
                    </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_detalle = false" >
                    <v-icon>cancel</v-icon> Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="modal_adjuntos" max-width="80%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal_adjuntos = false" class="white--text" >cancel</v-icon>
                    <span class="subheading" >
                        <strong>Documentos adjuntos del pedimento: {{ pedimentoDetalle }}</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-container grid-list-md>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <exportar-excel :data="dataAdjuntosPedimento" :exportFields="excel_detalle" :name='"Adjuntos_"+pedimentoDetalle+".xlsx"'>
                      <v-btn dark small color="success" title="Exportar" v-tippy>
                            <v-icon dark>get_app</v-icon> Exportar
                        </v-btn>
                    </exportar-excel>
                  </v-card-actions>
                        <v-client-table ref="adjuntosPedimento" :data="dataAdjuntosPedimento"
                            :columns="columns_detalle" :options="options_detalle" class="elevation-2 pa-2 scroll-table" >
                            <template slot="noResults" >
                                <v-alert :value="true" icon="info" color="info" >No se encontraron resultados...</v-alert>
                            </template>
                            <template slot="tipo_documento" slot-scope="props" >
                                  <div class="tipo_documento" >
                                  {{ props.row.tipo_documento }}
                                  </div>
                              </template>
                            <template slot="actions" slot-scope="props" >
                                <v-btn text icon color="primary" title="Descargar"
                                    @click="downloadFile(props.row.key)" >
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </template>
                        </v-client-table>
                    </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_adjuntos = false" >
                    <v-icon>cancel</v-icon> Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
  created: function() {
    this.URL = this.$hostname + "reportes/";
    this.loading = false;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario")
        this.permisoEliminar = true;
    this.cargarChecklist();
    this.getTiposDocumentos();
    this.cargar();
  },
  data: () => ({
    permisoEliminar: false,
    tab: null,
    checks: [],
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "E-Drive",
          disabled: true,
          to: ""
      },
      {
        text: "Consultar Archivos Adjuntos",
        disabled: true,
        to: ""
      }
    ],
    tipos: [{
      "id": 1,
      "text": "Por Pedimento | Listado de Pedimentos"
    }, {
      "id": 2,
      "text": "Por Fechas de Pedimento"
    }],
    dialog1: false,
    dialog2: false,
    listado:"",
    datos: [],
    columns: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id:"No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: true,
    show_loading: true,
    model: {
      rfc: "",
      usuario: "",
      pedimento: "",
      fecha_de: "",
      fecha_a: "",
      //reporte_url: "/reportes_vucem/consultar_diagnostico/",
      reporte_url: "/reportes_ws/consulta_adjuntos/",
      nombre_reporte: "Consulta Adjuntos Pedimentos",
      tipo: "Consulta Adjuntos Pedimentos",
      tipo_reporte: "",
      archivo: "", //para buscar por nombre de adjunto
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    modal:false,
        data_resumen:[],
        data_resumen_preview:[],
        data_resumen_excel: {
            "Tipo Operación":"tipo_operacion",
            "patente":"patente",
            "Sección Aduanera":"seccion_aduanera",
            "Número Pedimento":"numero_pedimento",
            "Fecha Pago Real":"fecha_pago_real",
            "Fecha Entrada":"fecha_entrada",
            "Año":"anio",
            "Mes":"mes",
            "T.C.":"tipo_cambio",
            "Clave Documento":"clave_documento",
            "Cantidad Adjuntos":"adicionales",
            "Tipo Pedimento":"tipo_pedimento",
            "Validación Check List":"checklist"
        },
        columns_resumen: ["tipo_operacion","patente","numero_pedimento","fecha_pago_real",
            "mes","clave_documento","adicionales","tipo_pedimento","checklist"],
        options_resumen: {
            filterable: ["tipo_operacion","patente",,"numero_pedimento","fecha_pago_real",
            "mes","clave_documento","adicionales","tipo_pedimento","checklist"],
            sortable: ["tipo_operacion","patente",,"numero_pedimento","fecha_pago_real",
            "mes","clave_documento","adicionales","tipo_pedimento","checklist"],
            headings: {
                tipo_operacion:"Tipo Operacion",
                patente:"Patente",
                numero_pedimento:"Número Pedimento",
                fecha_pago_real:"Fecha Pago Real",
                mes:"Mes",
                clave_documento:"Clave Documento",
                adicionales:"Cantidad Adjuntos",
                tipo_pedimento:"Tipo Pedimento",
                checklist:"Validación Check List",
            },
        },

        data_detalle:[],
        data_detalle_excel: {
            "Tipo Operación":"tipo_operacion",
            "patente":"patente",
            "Sección Aduanera":"seccion_aduanera",
            "Número Pedimento":"numero_pedimento",
            "Fecha Pago Real":"fecha_pago_real",
            "Fecha Entrada":"fecha_entrada",
            "Año":"anio",
            "Mes":"mes",
            "T.C.":"tipo_cambio",
            "Clave Documento":"clave_documento",
            "Tipo Pedimento":"tipo_pedimento",
            "Nombre de Elemento Entregado":"elemento",
            "Fuente":"fuente",
            "Nombre del Documento":"filename",
            "Nombre Contenido Relacionado":"contenido",
            "Tipo de Documento":"tipo_documento",
            "Usuario Adjuntó":"usuario",
            "Perfil":"perfil_usuario",
            "Tipo Usuario":"tipo_usuario",
            "Fecha Adjuntó":"fecha_subida"
        },
        dataAdjuntosPedimento:[],
        columns_detalle: ["elemento","filename","tipo_documento",
            "usuario","perfil_usuario","fecha_subida","actions"],
        options_detalle: {
            filterable: ["elemento","filename","tipo_documento",
            "usuario","perfil_usuario","fecha_subida"],
            sortable: ["elemento","filename","tipo_documento",
            "usuario","perfil_usuario","fecha_subida"],
            headings: {
              "elemento":"Extensión",
              "filename":"Nombre del Documento",
              "tipo_documento":"Tipo de Documento",
              "usuario":"Usuario Adjuntó",
              "perfil_usuario":"Perfil",
              "fecha_subida":"Fecha Adjuntó",
              "actions":"Descarga",
            },
        },
        porcentaje_detalle:{
          "Documentos Adjuntos":"documentos",
          "Clave Documento":"clave",
          "Descripción Documento":"descripcion",
          "Porcentaje":"porcentaje",
        },
        excel_detalle: {
            "Exttensión":"elemento",
            "Nombre del Documento":"filename",
            "Tipo de Documento":"tipo_documento",
            "Usuario Adjuntó":"usuario",
            "Perfil":"perfil_usuario",
            "Fecha Adjuntó":"fecha_subida"
        },
        data_descargas:[],
        data_descargas_excel: {
            "Fecha Descarga":"fecha",
            "Usuario":"usuario"
        },
        tiposDocumentos:[],
        dataChecklist:{
          items:[],
          columnsFiltrados:['documentos','clave','descripcion','porcentaje'],
          optionsFiltrados:{
              rowClassCallback: function(row) { return row.documentos!=''?'text-success':'text-danger'},
              filterable: [],
              sortable: [],
              orderBy: {
                  column: 'clave',
                  ascending: true
              },
              headings: {
                  documentos:"Documentos Adjuntos",
                  clave: "Clave",
                  descripcion: "Descripción",
                  porcentaje:"Porcentaje",
              } ,
          },
        },
        titleModalDetalle: "",
        cumplimientoCheck: "",
        modal_detalle:false,
        modal_adjuntos:false,
        pedimentoDetalle:"",
  }),
  methods: {
    openModalAdjuntos: async function(pedimento){
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        let x = await this.getDataAdjuntosPedimento(pedimento);
        this.pedimentoDetalle = pedimento;
        this.modal_adjuntos=true;
        this.$root.$dialogLoader.hide();
    },
    getDataAdjuntosPedimento: async function(pedimento){
      var thisObject = this;
      var data = {
            rfc: this.$local_storage.get("rfc"),
            pedimento: pedimento,
            tipo_reporte:1, //Para que busque por pedimento
        };
      return new Promise(function (resolve, reject) {
        axios.post(thisObject.$hostname + "reportes_ws/get_adjuntos_pedimento/", data)
        .then(response => {
            if(response.data!=undefined){
                thisObject.dataAdjuntosPedimento = response.data;
            }
            resolve(true);
        })
        .catch(error => {
            console.log(error);
            thisObject.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al obtener los adjuntos del pedimento. Favor de comunicarse con soporte.",
                footer: ""
            });
            resolve(true);
        });
      });
    },
    openModalDetalle: async function(nombreCheck,pedimento, anio){
      try {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var nombre_checklist = nombreCheck.split(":");
        let x = await this.getDataAdjuntosPedimento(pedimento);
        var tiposDelCheck = [];
        for(var k in this.checks){
          if (this.checks[k].nombre == nombre_checklist[0])
            tiposDelCheck = this.checks[k].opciones.tipos_documento;
        }
        this.dataChecklist.items = this.getTiposFiltrados(tiposDelCheck);
        var DocumentosDetalle = this.getTiposDetalle(pedimento, anio);
        var arrTiposDetalle = DocumentosDetalle["tipos"];
        var arrNombresDetalle = DocumentosDetalle["nombres"];
        for(var k in this.dataChecklist.items){
          if(arrTiposDetalle.includes(this.dataChecklist.items[k].clave)){
            this.dataChecklist.items[k]["documentos"] = this.getNombreDocumentosPorTipo(this.dataChecklist.items[k].clave, arrNombresDetalle);
          }
          else{
            this.dataChecklist.items[k]["documentos"] = "";
            this.dataChecklist.items[k]["porcentaje"] = 0;
          }
        }
        this.cumplimientoCheck = nombreCheck;
        this.titleModalDetalle = "Pedimento: "+pedimento;
        this.$root.$dialogLoader.hide();
        this.modal_detalle=true;
      } catch (error) {
        console.log(error);
        this.$root.$dialogLoader.hide();
      }
    },
    getNombreDocumentosPorTipo:function(tipo, arrDocumentos){
      var result = [];
      for(var k in arrDocumentos){
        if (arrDocumentos[k]["tipo"] == tipo){
          result.push(arrDocumentos[k]["nombre"])
        }
      }
      return result.join(" | ");
    },
    getTiposDetalle(pedimento, anio){
      try {
            var result=[];
            var tipos = [];
            this.dataAdjuntosPedimento.forEach(function (ele) {
                    if(ele.numero_pedimento==pedimento && ele.anio==anio){
                      var nombre = ele.filename.split("_");
                      if(nombre[0]!=undefined){
                        var key = ele.key.split("/");
                        tipos.push(nombre[0]);
                        result.push({"tipo":nombre[0],"nombre":key[key.length - 1]});
                      }

                    }
                });
            return {"tipos":tipos, "nombres":result};
        } catch (error) {
            console.log("Error",error);
            return {"tipos":[], "nombres":[]};
        }
    },
    getTiposFiltrados: function (arr) {
        try {
            var filtro = this.tiposDocumentos
                .filter(function (ele) {
                    return arr.includes(ele.clave);
                });
            var porcentaje = 0;
            if(filtro.length>0)
              porcentaje = parseInt(100/parseInt(filtro.length));

            for (var k in filtro){
              filtro[k]["porcentaje"] = porcentaje;
            }
            return filtro;
        } catch (error) {
            console.log("Error",error);
            return [];
        }
    },
     getTiposDocumentos: function(){
        var data = {
            tabla: 25,
        };
        axios.post(this.$hostname + "apendices/lista/", data)
        .then(response => {
            if(response.data!=undefined){
                this.tiposDocumentos = response.data;
            }
        })
        .catch(error => {
            console.log(error);
            this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al obtener los tipos de documento.",
                footer: ""
            });
        });
    },
    validaArchivo: function(){
        if (this.model.archivo != ""){
            this.model.archivo = this.model.archivo.trim();
            if (this.model.archivo.toString().length <4){
              return "Nombre Documento no debe tener menos de 4 caracteres";
            }
        }
        return true;
    },
    validaPedimento: function(){
        if (this.model.pedimento != ""){
            if (!this.validarPatronPedimento(this.model.pedimento))
                return "Pedimento no válido. Ejemplo: 240-0123-0000123";
        }
        return true;
    },
    validarPatronPedimento(pedimento){
        const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
        return patternPedimento.test(pedimento);
    },
    validaListado: function(){
        var listadoSinEspacios = this.removerLineasVacias(this.listado);
        if (listadoSinEspacios.length == 0) {
            return "Ingrese al menos 1 pedimento. Favor de verificar.";
        } else if (listadoSinEspacios.length > 50){
            return "No se puede consultar mas de 50 pedimentos";
        } else {
            for(var k in listadoSinEspacios){
                if (!this.validarPatronPedimento(listadoSinEspacios[k]))
                    return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
            }
        }

        return true;
    },
    validaListadoPreview: function(){
        var listadoSinEspacios = this.removerLineasVacias(this.listado);
        if (listadoSinEspacios.length == 0) {
            return "Ingrese al menos 1 pedimento. Favor de verificar.";
        } else if (listadoSinEspacios.length > 10){
            return "No se puede consultar mas de 10 pedimentos en Vista Previa";
        } else {
            for(var k in listadoSinEspacios){
                if (!this.validarPatronPedimento(listadoSinEspacios[k]))
                    return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
            }
        }

        return true;
    },
    removerLineasVacias(listado){
        var listadoSplit = this.listado.split("\n");
        var listadoSinEspacios = listadoSplit.filter(item => {
            return item.trim() != "";
        });
        return listadoSinEspacios;
    },
    validaFecha: function(fecha){
        if (fecha == "Invalid date")
            return "Fecha no válida."
        else
          return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 7)
          return "Periodo máximo de consulta 7 dias. Favor de verificar."
      }
      return true;
    },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        tipo: this.model.tipo
      };
      axios.post(this.URL + "get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
              this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminados(this.datos[k].criterio);
            }
          }
        })
        .catch(err => {
         console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          if (params.tipo_reporte == 1) {
            if (params.lista!= undefined && params.lista.length>0){
                return "Buscado por lista de pedimentos: "+params.lista.length;
            } else
              return "Pedimento: " + params.pedimento;
          } else if (params.tipo_reporte == 4) {
              return "Documento: " + params.archivo;
          } else {
            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          }
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }

    },
    get_data_view: function(opcion=0) {
      if (!this.$refs.form1.validate() && opcion==0) {//Opción sirve para saltar la validación cuando se busca por listado
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        data["lista"] = this.removerLineasVacias(this.listado);
        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.archivo == '') delete(data['archivo']);

        axios({
            method: "post",
            url: this.$hostname + "reportes_ws/consulta_adjuntos_preview/",            
            data: data
          })
          .then(res => {
            this.data_resumen_preview = res.data.resumen;
            for (var k in this.data_resumen_preview) {
                this.data_resumen_preview[k].fecha_pago_real = this.parseDate(this.data_resumen_preview[k].fecha_pago_real);
            }
          })
          .catch(error => {
            console.log(error);
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al generar la vista previa. Favor de comunicarse con soporte.",
              footer: ""
            });
          }).then(() => {
            this.listado="";
            this.$root.$dialogLoader.hide();
          });
      }
    },
    obtenerConfigurablesPreview: function(){
      for(var key in this.data_resumen_preview){//Obtenemos los configurables
        if(this.data_resumen_preview[key]["configurables"] != undefined && this.data_resumen_preview[key]["configurables"] !=""){
            var configurables = JSON.parse(this.data_resumen_preview[key]["configurables"]);
            for(var k in configurables){
              this.data_resumen_preview[key][configurables[k].nombre] = configurables[k].porcentaje;
            }
        }
      }
    },
    obtenerConfigurables: function(){
      for(var key in this.data_resumen){//Obtenemos los configurables
        if(this.data_resumen[key]["configurables"] != undefined && this.data_resumen[key]["configurables"] !=""){
            var configurables = JSON.parse(this.data_resumen[key]["configurables"]);
            for(var k in configurables){
              this.data_resumen[key][configurables[k].nombre] = configurables[k].porcentaje;
            }
        }
      }
    },
    generar_reporte_sqs(opcion=0) {
      if (!this.$refs.form.validate() && opcion==0) {//Opción sirve para saltar la validación cuando se busca por listado
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        data["lista"] = this.removerLineasVacias(this.listado);
        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.archivo == '') delete(data['archivo']);

        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
                mensaje = error.response.data.mensaje;
                if (error.response.status == 406){
                    titulo = "¡Ya existe un reporte en proceso!";
                    tipo = "info";
                }
            } else {
                mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
                type: tipo,
                title: titulo,
                text: mensaje,
                footer: ""
            });
          }).then(() => {
            this.listado="";
            this.cargar();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    generaReporteListado(tipoReporte){
        if (this.$refs.formListado.validate()) {
            if (tipoReporte == "completo"){
              this.generar_reporte_sqs(1);
            }else{
              this.get_data_view(1);
            }
            this.dialog1 = false;
            this.dialog2 = false;
        }
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    clear_values() {
      this.model.pedimento = '';
      this.model.fecha_de = '';
      this.model.fecha_a = '';
      this.model.archivo = '';
      this.listado = "";
    },
    base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    cargarDetalle: function (idReporte) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                "id_reporte": idReporte
            };
            axios.post(this.$hostname + "reportes_ws/get_bitacora_descarga/", data)
                .then(res => {
                    if (typeof res.data != undefined) {
                        this.data_resumen = res.data.resumen;
                        this.data_detalle = res.data.detalle;
                        this.obtenerConfigurables();

                        for (var k in this.data_resumen) {
                            this.data_resumen[k].fecha_pago_real = this.parseDate(this.data_resumen[k].fecha_pago_real);
                            this.data_resumen[k].fecha_entrada = this.parseDate(this.data_resumen[k].fecha_entrada);
                        }
                        this.modal = true;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los detalles del expediente.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();

                });
        },
        eliminarReporte: function (idreporte) {
          this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                      this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                    });
              }
          })
        },
        cargarChecklist: function () {
            let data = {
                rfc: this.$local_storage.get("rfc"),
            };
            axios
                .post(this.$hostname + "catalogos/configurables/get_configurables/", data)
                .then(response => {
                    this.checks = response.data;
                    //var checks = [];
                    for (var k in this.checks) {
                      this.checks[k].nombre = this.checks[k].prefijo+"_"+this.checks[k].nombre;
                      this.checks[k].opciones = JSON.parse(this.checks[k].opciones);
                    }
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: ""
                    });
                });
        },

  },
};
</script>
<style scoped>
.showModal {
    cursor: pointer;
    border-bottom: 1px dotted;
    text-align: center;
    color: blue;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color:black;
    font-size: small ;
    background-color: #EEEEEE;
    padding: 0px;
}
.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small ;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}
.v-tabs-slider-wrapper {
    left: 0 !important;
}
.table-bordered thead th, .table-bordered thead td {
    font-size: xx-small !important;
}
.elevation-2 >>> .tipo_documento{
    white-space: normal !important;
    max-width: 550px !important;
    text-align: justify !important;
}
.elevation-2 >>> .documentos_checklist{
    white-space: normal !important;
    max-width: 550px !important;
    min-width: 450px !important;
    text-align: justify !important;
}
.elevation-2 >>> .documentos_descripcion{
    white-space: normal !important;
    max-width: 250px !important;
    min-width: 100px !important;
    text-align: justify !important;
}
</style>
